/* eslint-ignore */
// @ts-nocheck
import React, { useCallback, useEffect } from 'react';
import { pushGtmEvent } from 'analytics/gtm';
import { useAuth } from 'hooks/authHook';
import api from 'services/api';
import { normalizeDocumentForPayload } from 'utils/document';

const script =
  'https://www5.directtalk.com.br/clientes/custom/AeC_Ultragaz_3/widget.min.js';

export default function ChatTwillo() {
  const { userData } = useAuth();

  const getUserData = async () => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    const response = await api.get(
      'industrial/customer/v1/customers/me',
      parameters
    );

    return response.data;
  };

  const loadScript = async (source) => {
    const existingScript = document.getElementById('dt-widget');
    const existingDiv = document.getElementById('bot');
    const existingIframe = document.getElementById('dtbot-iframe');
    const existingHiCustomWidget = document.getElementById('hi-custom-widget');
    const existingStyle = document.getElementById('widget-style');
    const dtBOTfloater = document.getElementsByClassName('dt-BOTfloater');
    const existingDtScript = document.getElementById('dtbot-script');
    if (existingDtScript) existingDtScript.remove();

    if (dtBOTfloater.length > 0) dtBOTfloater[0].remove();
    if (existingIframe) existingIframe.remove();
    if (existingHiCustomWidget) existingHiCustomWidget.remove();

    if (existingScript) existingScript.remove();
    if (existingDiv) existingDiv.remove();
    if (existingStyle) existingStyle.remove();

    const scriptBot = document.createElement('script');
    scriptBot.src = source;
    scriptBot.id = 'dt-widget';
    document.body.appendChild(scriptBot);

    setInterval(() => {
      const dtBOTfloaterchat = document.getElementsByClassName('dt-BOTfloater');
      for (let i = 0; i < dtBOTfloaterchat.length; i += 1) {
        if (dtBOTfloaterchat[i]) {
          dtBOTfloaterchat[i].remove();
        }
      }
    }, 10);
  };

  const loadScriptNotLogged = async () => {
    const existingScript = document.getElementById('dt-widget');
    const existingHiCustomWidget = document.getElementById('hi-custom-widget');
    const existingDiv = document.getElementById('bot');
    const existingIframe = document.getElementById('dtbot-iframe');
    const existingStyle = document.getElementById('widget-style');
    const existingDtScript = document.getElementById('dtbot-script');
    const dtBOTfloater = document.getElementsByClassName('dt-BOTfloater');
    if (dtBOTfloater.length > 0) dtBOTfloater[0].remove();

    if (existingHiCustomWidget) existingHiCustomWidget.remove();
    if (existingDtScript) existingDtScript.remove();
    if (existingScript) existingScript.remove();
    if (existingDiv) existingDiv.remove();
    if (existingIframe) existingIframe.remove();
    if (existingStyle) existingStyle.remove();

    const url =
      'https://www5.directtalk.com.br/clientes/custom/AeC_Ultragaz_2/widget.min.js';

    const scriptBot = document.createElement('script');

    scriptBot.src = `${url}`;
    scriptBot.id = 'dt-widget';
    document.body.appendChild(scriptBot);
  };

  const getUserDataChat = useCallback(async (userDataParam) => {
    if (
      Object.keys(userDataParam).length > 0 &&
      !userDataParam.accessToken &&
      !userDataParam.refreshToken
    ) {
      return;
    }
    if (
      Object.keys(userDataParam).length > 0 &&
      !!userDataParam.accessToken &&
      !!userDataParam.refreshToken
    ) {
      const userDataResponse = await getUserData();
      const documentParam = encodeURIComponent(
        normalizeDocumentForPayload(userDataResponse.document || '')
      );

      loadScript(
        `${script}?nome_usuario=${
          userDataResponse.corporateName || 'Sem nome'
        }&email=${userDataResponse.email || 'noemail@noemail.com'}&telefone=${
          userDataResponse.phoneNumber
            ? `${userDataResponse.phoneDdd || ''}${
                userDataResponse.phoneNumber || ''
              }`
            : '(12) 4001-9000'
        }&cpfcnpj=${documentParam}&termos=termos`
      );
    } else {
      loadScriptNotLogged();
    }
  }, []);

  useEffect(() => {
    (async () => {
      await getUserDataChat(userData);
    })();
  }, [userData]);

  useEffect(() => {
    const onDocClick = (e) => {
      const el = e.target;
      if (!el || typeof el.closest !== 'function') return;
      if (
        el.closest('#bot') ||
        el.closest('.dt-BOTfloater') ||
        el.closest('[id^="dtbot"]') ||
        el.closest('#hi-custom-widget') ||
        el.closest('#dt-widget')
      ) {
        pushGtmEvent({
          event: 'click_cta',
          eventCategory: 'home',
          eventAction: 'click',
          eventLabel: 'Posso ajudar?',
          pageSection: 'home',
          elementType: 'chat',
        });
      }
    };
    document.addEventListener('click', onDocClick, true);
    return () => document.removeEventListener('click', onDocClick, true);
  }, []);

  return <></>;
}
